// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3E0w8","left":"styles_left__3Xy-E"};